import type { PlanStrategy } from '@/lib/ai-agent/schemas/plan-strategy';

/** JSON persisted while a project may have guidance but no generated strategy yet. */
export type StoredProjectStrategy = Partial<PlanStrategy>;

export function hasMaterializedProjectStrategy(strategy: unknown): boolean {
  if (!strategy || typeof strategy !== 'object' || Array.isArray(strategy)) return false;
  const value = strategy as { pillars?: unknown; schedule?: unknown };
  return (
    (Array.isArray(value.pillars) && value.pillars.length > 0) ||
    (Array.isArray(value.schedule) && value.schedule.length > 0)
  );
}
